module.exports = __webpack_public_path__ + "media/images/case-pic1-3b332281.png";